import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { fetchAgreements } from "../../apis/agreementsApi";
import "./Agreements.css";

const Agreements = () => {
  const [agreements, setAgreements] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const loadAgreements = async () => {
      try {
        const res = await fetchAgreements();
        setAgreements(res.data);
      } catch (err) {
        message.error("Error al cargar los convenios. Contacta al soporte.");
        setAgreements([]);
      }
    };
    loadAgreements();
  }, []);

  return (
    <div className="agreements-collage">
      {agreements.map(agreement => (
        <div
          key={agreement.id}
          className="agreement-image-wrapper d-flex my-3"
          onClick={() => navigate(`/agreements/${agreement.slug}`, { state: { agreement } })}
          style={{ cursor: "pointer" }}
          title={agreement.name}
        >
          <img
            src={`/img/agreements/${agreement.img}`}
            alt={agreement.name}
            className="agreement-image"
          />
          <div className="agreement-name-overlay">{agreement.name}</div>
        </div>
      ))}
    </div>
  );
};

export default Agreements;